// extracted by mini-css-extract-plugin
module.exports = {"notesBoxContainer":"A4sUxTfA","notesBoxHeader":"zGo90AkC","notesButton":"_2zFRwSZn","notesArea":"_3l7NIVjt","editorWrapper":"_1vPfFBVS","titleInput":"_343x1DHj","richTextEditor":"_2zOFhMBa","myInputRichTextContainer":"_2ugutMYc","height100":"_3CiDTVS9"};
    if(module.hot) {
      // 1746735834096
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  